import {PhoneValidator} from "@/validators/PhoneValidator";
import {RangeValidator} from "@/validators/RangeValidator";
import {AddressTitle, Salutation} from "@/helpers/constants";
import {enumToArray} from "@/helpers/functions_asi";
import {MultipleEmailsValidator} from "@/validators/MultipleEmailsValidator";
import RequiredValidator from "@/validators/RequiredValidator";

export default class AddressRules {

	public static phoneRules(countryCode: string | null = null): any[] {
		return [
			(new PhoneValidator('address.phone', true, countryCode)).validationRule(),
		];
	}

	public static emailRules(isRequired: boolean): any[] {
		if (isRequired) {
			return [
				(new RequiredValidator('address.emails')).validationRule(),
				(new MultipleEmailsValidator('address.emails')).validationRule(),
			];
		} else {
			return [
				(new MultipleEmailsValidator('address.emails')).validationRule(),
			];
		}
	}

	public static readonly salutationRules = [
		(new RangeValidator('address.salutation', true, enumToArray(Salutation).map(s => s.value))).validationRule(),
	];

	public static readonly titleRules = [
		(new RangeValidator('address.title', true, enumToArray(AddressTitle).map(a => a.value))).validationRule(),
	];

}
